import { Typography } from '@mui/material';
import { DialogHeader } from '../../../shared/dialog';

import { IAudienceCustomDialogHeader } from './types';

import ArrowBack from 'assets/icons/buttons/arrow-back.svg';
import { styles } from './styles';

export const AudienceCustomDialogHeader = ({ onCancel }: IAudienceCustomDialogHeader) => {
  return (
    <DialogHeader>
      <ArrowBack style={styles.arrowBack} onClick={onCancel} />
      <Typography sx={styles.audienceName}>Custom Audience</Typography>
      <Typography sx={styles.infoAboutModal}>Add members to your custom audience</Typography>
    </DialogHeader>
  );
};
